
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoshegaoninnovacrysta() {



    const cardData =
    {
        keyword: 'Pune to Shegaon Innova Crysta Cab Service',
        heading: 'Meghana Cab : Pune to Shegaon Innova Crysta Cab Service',
        headingDescription: 'Meghana Cab offers Pune to Shegaon Innova Crysta Cab Service, delivering a serene, spacious, and spiritually enriching travel experience for devotees visiting the sacred town of Shegaon, home to the revered Shri Gajanan Maharaj temple. Covering approximately 547 km over an 8–10 hour drive via the Mumbai–Pune Expressway and NH 6/NH 48, our premium Innova Crysta vehicles feature plush leather interiors, generous legroom, spacious luggage compartments, and full air-conditioning . Ideal for one-way or round-trip journeys, this service includes door-to-door pickups from any location in Pune, experienced chauffeurs with route and comfort expertise, GPS-enabled cars, and flexible scheduling. Book your Pune to Shegaon Innova Crysta Cab with Meghana Cab for a stress-free, dignified, and memorable pilgrimage journey.',


        top: ' Top Places to Visit in Shegaon with Meghana Cab',

"topPlaces": [
  {
    "title": "Shri Sant Gajanan Maharaj Temple",
    "description": "The spiritual heart of Shegaon and the ‘Pandharpur of Vidarbha’, this temple is built over the samādhi of 19th-century saint Gajanan Maharaj. Adorned with intricate architecture, daily aartis, and massive pilgrimage crowds, it’s the focal point of devotion and social upliftment."
  },
  {
    "title": "Anand Sagar Complex",
    "description": "A vast spiritual-and-recreation hub created by the temple trust, featuring an artificial lake, landscaped gardens, amphitheater, mini-zoo, musical fountain, meditation halls, and boat rides—perfect for family visits and wellness."
  },
  {
    "title": "Shri Gajanan Maharaj Sansthan Museum",
    "description": "Housed within the temple premises, this museum chronicles the life, teachings, and miracles of Sant Gajanan through photographs, manuscripts, and historical artifacts—a must-visit for devotees and history buffs."
  },
  {
    "title": "Shri Sant Gajanan Maharaj College of Engineering",
    "description": "Located in a serene campus, this engineering institute founded by the temple trust reflects the saint’s legacy of education and community service, offering modern technical courses in an atmosphere of spiritual values."
  },
  {
    "title": "Shegaon Municipal Garden & Botanical Park",
    "description": "A lush green space near the temple featuring ornamental plants, shaded walkways, benches, and a calm environment—an ideal spot for morning strolls or quiet reflection."
  },
  {
    "title": "Shrikhetra Nagzari & Nearby Temples",
    "description": "On the outskirts of the town lies this spiritual site alongside small temples and a village atmosphere—offering a peaceful extension to the devotional circuit."
  },
  {
    "title": "Amba Barwa Wildlife Sanctuary",
    "description": "About 60 km from Shegaon, this Satpuda‑hills sanctuary offers forest trails, wildlife spotting in tiger‑reserve buffer zones, and dam views—ideal for nature lovers seeking a day trip."
  },
  {
    "title": "Lonar Crater Lake (Day Trip)",
    "description": "Approximately 100 km away, Lincoln’s meteorite crater filled with saline water is a geological wonder. Visitors can explore its rim, nearby temples, and rare lake ecology—a great complement to Shegaon’s spiritual journey."
  },
  {
    "title": "Local Markets & Street‑Food",
    "description": "Stalls around the temple offer devotional mementos, serene handicrafts, plus Shegaon’s special poha and kachori—perfect for pilgrims seeking a taste of local life."
  }
],

 "services": [
    {
      "name": "Pune to Shegaon Innova Crysta Cab Booking",
      "description": "Book a comfortable and spacious Innova Crysta cab for your journey from Pune to Shegaon, home to the famous Gajanan Maharaj Temple. Our cab service ensures a smooth ride across long distances, with well-maintained vehicles and courteous chauffeurs for a serene pilgrimage experience."
    },
    {
      "name": "One Way Innova Crysta Pune Shegaon",
      "description": "Opt for a one-way Innova Crysta taxi from Pune to Shegaon—ideal for devotees, families, and solo travelers looking for a hassle-free drop without return charges."
    },
    {
      "name": "Round Trip Innova Crysta Pune Shegaon",
      "description": "Planning to return the same day or later? Book our round-trip Innova Crysta cab from Pune to Shegaon for a smooth journey both ways with the same vehicle and driver at your service."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Shegaon",
      "description": "Beat the heat and travel in comfort with our air-conditioned Innova Crysta taxis. The journey to Shegaon becomes pleasant, even in warm weather conditions."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Shegaon",
      "description": "Our experienced and polite chauffeurs ensure a safe and smooth trip from Pune to Shegaon, taking care of routes, breaks, and on-road assistance throughout the journey."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Shegaon",
      "description": "Enjoy complete privacy and comfort with a private Innova Crysta taxi. Ideal for family pilgrimages or small group tours to Shegaon with zero shared rides."
    },
    {
      "name": "Online Booking Innova Crysta Pune Shegaon",
      "description": "Book your Innova Crysta cab online in just a few clicks. Check live availability, confirm pricing, and schedule your Pune to Shegaon ride conveniently through our user-friendly platform."
    },
    {
      "name": "Shegaon Pilgrimage Innova Crysta",
      "description": "Embark on a spiritual journey to Gajanan Maharaj Sansthan with our specially curated pilgrimage cab services in an Innova Crysta. Enjoy peace and focus on your devotion while we handle the travel."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Shegaon",
      "description": "Travel in total comfort with our well-equipped Innova Crysta cabs. Plush seating, smooth rides, ample legroom, and luggage space ensure a stress-free ride to Shegaon."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Shegaon",
      "description": "Get premium quality travel at budget-friendly prices. Our economical Innova Crysta taxi service makes long-distance religious trips from Pune to Shegaon affordable and reliable."
    },
    {
      "name": "Religious Tour Innova Crysta Pune",
      "description": "Planning a religious circuit? Our Innova Crysta taxis are ideal for visiting spiritual destinations like Shegaon, Pandharpur, or Shirdi from Pune—safe, peaceful, and reliable."
    },
    {
      "name": "Family Trip Innova Crysta Shegaon",
      "description": "Heading to Shegaon with your family? Our Innova Crysta provides 6–7 seats, luggage room, reclining seats, and AC for a pleasant family outing or pilgrimage."
    },
    {
      "name": "Reliable Innova Crysta Taxi Shegaon",
      "description": "Count on us for timely pickups, well-maintained vehicles, and experienced drivers. Our Shegaon-bound Innova Crysta cabs offer dependable service every time."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Our Innova Crysta cabs are built for long journeys like Pune to Shegaon. Enjoy superior road grip, AC comfort, and an enjoyable ride with trusted drivers."
    },
    {
      "name": "Weekend Trip Innova Crysta Shegaon",
      "description": "Plan a weekend spiritual retreat to Shegaon in our Innova Crysta cab. Flexible return options and peaceful road trips make it perfect for weekend spiritual refreshment."
    }
  ],
  "tableData": [
    ["Pune to Shegaon Innova Crysta Cab Booking", "One Way Innova Crysta Pune Shegaon"],
    ["Round Trip Innova Crysta Pune Shegaon", "AC Innova Crysta Taxi Pune Shegaon"],
    ["Chauffeur Driven Innova Crysta Pune Shegaon", "Private Innova Crysta Taxi Pune Shegaon"],
    ["Online Booking Innova Crysta Pune Shegaon", "Shegaon Pilgrimage Innova Crysta"],
    ["Comfortable Innova Crysta Cab Pune Shegaon", "Budget Innova Crysta Taxi Pune Shegaon"],
    ["Religious Tour Innova Crysta Pune", "Family Trip Innova Crysta Shegaon"],
    ["Reliable Innova Crysta Taxi Shegaon", "Long Distance Innova Crysta Taxi"],
    ["Weekend Trip Innova Crysta Shegaon", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Cab from Pune to Shegaon",
    "WhyChoosedescription": "Travel from Pune to the sacred town of Shegaon in a premium Innova Crysta cab, perfect for visiting the renowned Gajanan Maharaj Temple. Our cab service ensures a smooth, spiritual, and comfortable journey for devotees and families alike."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Travel Experience",
    "WhyChoosedescription": "The Innova Crysta is ideal for long-distance journeys, offering reclining seats, ample legroom, rear AC vents, and spacious luggage space. Whether you're traveling with elders or children, enjoy a fatigue-free ride on the 550+ km route."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Knowledge of the Shegaon Route",
    "WhyChoosedescription": "Our trained chauffeurs are experienced in handling long highway drives and familiar with the best Pune–Aurangabad–Shegaon routes. They ensure a safe, punctual, and respectful travel experience for all pilgrims."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "Every Innova Crysta undergoes deep cleaning and routine maintenance before your trip. We maintain high safety and hygiene standards to ensure your journey to Shegaon is worry-free and peaceful."
  },
  {
    "WhyChooseheading": "Flexible Booking Options – One-Way, Round Trip, or Overnight Stay",
    "WhyChoosedescription": "Whether you plan a same-day return or wish to stay overnight at Shegaon, we offer customizable packages with door-to-door pickup and drop across Pune. You can adjust halts, stops, and durations as per your schedule."
  },
  {
    "WhyChooseheading": "All-Inclusive and Transparent Pricing",
    "WhyChoosedescription": "Our Pune to Shegaon cab fare includes driver allowance, fuel, tolls, parking, and taxes. No hidden charges—just clear and honest pricing to support your pilgrimage journey."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimages, Family Trips, and Senior Citizens",
    "WhyChoosedescription": "Shegaon being a major spiritual destination, our Innova Crysta is best suited for family darshan trips, group pilgrimages, and travel with elderly devotees—ensuring maximum comfort and safety."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance and Travel Support",
    "WhyChoosedescription": "Our team is available round-the-clock to help with bookings, itinerary adjustments, route questions, or emergencies. We support your spiritual journey every step of the way."
  }
]
























    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab from Pune to Shegaon?",
        answer: "You can book your cab easily by calling Meghana Cab at +91 9075462128 or through our website for fast and confirmed bookings."
    },
    {
        question: "What is the distance and travel time from Pune to Shegaon?",
        answer: "The distance is approximately 550 km, and the journey takes around 10 to 11 hours depending on traffic and route conditions."
    },
    {
        question: "Is the Innova Crysta suitable for long trips like Pune to Shegaon?",
        answer: "Yes, the Innova Crysta is ideal for long-distance journeys with spacious seating and excellent comfort."
    },
    {
        question: "Can I book the Innova Crysta for a round trip to Shegaon?",
        answer: "Yes, we offer both one-way and round-trip options to meet your travel requirements."
    },
    {
        question: "Are the drivers familiar with the Pune to Shegaon route?",
        answer: "Yes, our drivers are experienced and well-acquainted with the Pune–Aurangabad–Shegaon route."
    },
    {
        question: "What is included in the cab fare to Shegaon?",
        answer: "The fare includes fuel, driver charges, and tolls. Parking and waiting charges, if any, may be additional."
    },
    {
        question: "Are your cabs sanitized before the trip?",
        answer: "Yes, all our vehicles are cleaned and fully sanitized before every journey to ensure passenger safety."
    },
    {
        question: "Can we request meal or rest stops on the way to Shegaon?",
        answer: "Yes, you can request breaks for meals, refreshments, or rest stops during the journey."
    },
    {
        question: "How many passengers can travel comfortably in an Innova Crysta?",
        answer: "The vehicle accommodates 6 to 7 passengers along with luggage, making it perfect for family or group travel."
    },
    {
        question: "What payment modes do you accept?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ashok Gawande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked an Innova Crysta for our Shegaon visit. The ride was comfortable and the driver was very polite and helpful.”',
    },
    {
        name: 'Mrs. Rekha Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth experience from booking to travel. Meghana Cab ensured our Shegaon trip was peaceful and safe.”',
    },
];








































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneToShegaonSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Shegaon Innova Crysta Cab Service",
  "description": "Book a reliable, chauffeur-driven AC Innova Crysta taxi from Pune to Shegaon for pilgrimage, religious tours, family trips, and weekend getaways. One way and round trip options with easy online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Pilgrimage Taxi Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Shegaon"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-shegaon-innova-crysta-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Shegaon Innova Crysta Cab Service | Pilgrimage & Family Taxi</title>
  <meta
    name="description"
    content="Comfortable chauffeur-driven Innova Crysta taxi service from Pune to Shegaon for pilgrimage, religious tours, and family trips. Book your AC cab online with budget and round trip options."
  />
  <meta
    name="keywords"
    content="Pune to Shegaon Innova Crysta Cab Booking, One Way Innova Crysta Pune Shegaon, Round Trip Innova Crysta Pune Shegaon, AC Innova Crysta Taxi Pune Shegaon, Chauffeur Driven Innova Crysta Pune Shegaon, Private Innova Crysta Taxi Pune Shegaon, Online Booking Innova Crysta Pune Shegaon, Shegaon Pilgrimage Innova Crysta, Comfortable Innova Crysta Cab Pune Shegaon, Budget Innova Crysta Taxi Pune Shegaon, Religious Tour Innova Crysta Pune, Family Trip Innova Crysta Shegaon, Reliable Innova Crysta Taxi Shegaon, Long Distance Innova Crysta Taxi, Weekend Trip Innova Crysta Shegaon"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToShegaonSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshegaoninnovacrysta;